import {Button} from '@/components/ui/button/Button'
import {DotsHorizontalIcon, Pencil01Icon, Trash01Icon} from '@/components/ui/icon/Icon'
import {UserGroup} from '@/features/user-groups/types'
import {useTranslation} from '@/translations/i18n'
import {MenuButton, MenuProvider} from '@ariakit/react'
import {FC} from 'react'
import {StyledGroupActionsMenu, StyledGroupActionsMenuItem} from './style'
import {Text} from '@/components/ui/text/Text'

interface GroupActionsMenuProps {
    group: UserGroup
    onEdit: (group: UserGroup) => void
    onDelete: (group: UserGroup) => void
}

export const GroupActionsMenu: FC<GroupActionsMenuProps> = ({group, onEdit, onDelete}) => {
    const {t} = useTranslation()

    return (
        <MenuProvider placement="bottom-end">
            <MenuButton
                render={
                    <Button variant="ghost" size="sm" shape="square">
                        <DotsHorizontalIcon />
                    </Button>
                }
            />
            <StyledGroupActionsMenu gutter={8} portal>
                <StyledGroupActionsMenuItem onClick={() => onEdit(group)}>
                    <Pencil01Icon size={16} />
                    <Text size="textSm">{t('commons:edit')}</Text>
                </StyledGroupActionsMenuItem>
                <StyledGroupActionsMenuItem $variant="danger" onClick={() => onDelete(group)}>
                    <Trash01Icon size={16} />
                    <Text size="textSm" palette="danger" shade="600">
                        {t('commons:delete')}
                    </Text>
                </StyledGroupActionsMenuItem>
            </StyledGroupActionsMenu>
        </MenuProvider>
    )
}
